"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  STRIPE_CHECKOUT_FAILED: 'STRIPE_CHECKOUT_FAILED',
  CARD_DECLINED: 'card_declined',
  INVALID_NUMBER: 'invalid_number',
  INVALID_EXPIRY_MONTH: 'invalid_expiry_month',
  INVALID_EXPIRY_YEAR: 'invalid_expiry_year',
  INVALID_CVC: 'invalid_cvc',
  INCORRECT_NUMBER: 'incorrect_number',
  EXPIRED_CARD: 'expired_card',
  INCORRECT_CVC: 'incorrect_cvc',
  INCORRECT_ZIP: 'incorrect_zip',
  PROCESSING_ERROR: 'processing_error'
};
exports.default = _default;
module.exports = exports.default;